import { Card, Row, Col } from 'react-bootstrap'
import EditCard from './EditCard'
import DeleteCard from './DeleteCard'
import { useSelector } from 'react-redux'
import { useState } from 'react'

export default function RoleCard({ role, getRoles }) {
  const { user: authUser } = useSelector(x => x.auth)
  const [isEditing, setIsEditing] = useState(false)
  const isWebmaster = Boolean(authUser?.user?.isWebmaster)
  const canEdit = isWebmaster

  return (
    <Col xs={12} md={12} lg={12}>
      {canEdit && isEditing ? (
        <>
          <EditCard
            role={role}
            getRoles={getRoles}
            showEditButton={false}
            onCancel={() => setIsEditing(false)}
            onSave={() => setIsEditing(false)}
          />
          {isWebmaster && (
            <DeleteCard
              role={role}
              getRoles={getRoles}
              showDeleteButton={true}
              onDelete={() => setIsEditing(false)}
              onCancel={() => setIsEditing(false)}
            />
          )}
        </>
      ) : (
        <Card className="roles-admin-card poll-static-card" id={`${role._id}-card`}>
          <Card.Header className="roles-admin-card-header">
            <div className='roles-admin-card-headline'>
              <h3 className='roles-admin-card-title mb-0'>{role.name}</h3>
              <span className='roles-admin-type-badge'>meeting role</span>
            </div>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className='roles-admin-description' dangerouslySetInnerHTML={{ __html: role.description }}></div>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className='roles-admin-card-footer'>
            {canEdit &&
              <Row>
                <Col xs={12} className="d-flex gap-2 roles-admin-actions">
                  <EditCard
                    role={role}
                    getRoles={getRoles}
                    showEditButton={true}
                    onEdit={() => setIsEditing(true)}
                  />
                  {isWebmaster && (
                    <DeleteCard
                      role={role}
                      getRoles={getRoles}
                      showDeleteButton={true}
                      onDelete={() => getRoles()} // Refresh events after deletion
                    />
                  )}
                </Col>
              </Row>
            }
          </Card.Footer>
        </Card>
      )}
    </Col>
  )
}